import { UniqueEntityID } from './UniqueEntityID'

export interface EntityProps {
  [key: string]: any
}

export interface EntityPojo extends EntityProps {
  id: string
}

export class Entity<T extends EntityProps, P extends EntityPojo | T = T> {
  protected readonly _id: UniqueEntityID
  public readonly props: T

  public constructor(props: T, id?: UniqueEntityID) {
    this._id = id || new UniqueEntityID()
    this.props = props
  }

  get id() {
    return this._id
  }

  public toPojo(): P {
    return {
      id: this.id.toString(),
      ...this.props
    } as P
  }
}
